// Format a GERIA-12 cell value for display: trim, normalise duplicated
// comparison operators, and round z-scores (params ending in "z") to 2dp.
export function formatGeria12Value(value, paramName) {
  if (value == null) return "";
  if (typeof value === "number") {
    if (paramName.endsWith("z")) return String(Math.round(value * 100) / 100);
    return String(value);
  }
  return String(value).replace(/≤\s*≤/g, "≤").replace(/≥\s*≥/g, "≥").trim();
}
